// extracted by mini-css-extract-plugin
export default {"bgDark":"App_bgDark__mkgmw","bgLight":"App_bgLight__zizJc"};